import PropTypes from "prop-types";
import { useState } from "react";

import {
  CircularProgress,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert,
  Grid,
  Box,
  Typography,
  Button,
} from "@mui/material";

import { useReactMediaRecorder } from "react-media-recorder";

function AudioRecorder({ displayName, fieldRef, options }) {
  console.log(options ? "" : "");
  const [fieldError, showFieldError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const [recordedAudio, setRecordedAudio] = useState(null);
  const [openRecordDialog, setOpenRecordDialog] = useState(false);

  function saveMediaBlob(blobUrl, blob) {
    // console.log(blobUrl);
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
      const base64data = reader.result;
      // console.log(base64data);
      setRecordedAudio(base64data);
    };
  }

  const { status, startRecording, stopRecording, mediaBlobUrl, clearBlobUrl } =
    useReactMediaRecorder({
      video: false,
      onStop: (blobUrl, blob) => {
        saveMediaBlob(blobUrl, blob);
      },
    });

  return (
    <Box mt={3}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openRecordDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <Box>Record Audio</Box>
        </DialogTitle>
        <DialogContent>
          <Box mt={2} mb={3} align="center">
            <Box>
              <Box mt={1}>
                <Box sx={{ position: "relative", display: "inline-flex" }}>
                  <CircularProgress
                    variant={status === "recording" ? "indeterminate" : "determinate"}
                    size={120}
                    thickness={2}
                    color={status === "recording" ? "success" : "primary"}
                    value={100}
                  />
                  <Box
                    sx={{
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      position: "absolute",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon color={status === "recording" ? "success" : "primary"} fontSize="large">
                      {status === "recording" ? "settings_voice" : "mic_none"}
                    </Icon>
                  </Box>
                </Box>
              </Box>
              <Box mt={1}>
                <Button
                  size="small"
                  circular
                  variant="contained"
                  color={status === "recording" ? "error" : "success"}
                  onClick={() => {
                    if (status === "recording") {
                      stopRecording();
                    } else {
                      clearBlobUrl();
                      startRecording();
                    }
                  }}
                >
                  {status === "recording" ? "Stop" : "Start"} Recording
                </Button>
              </Box>
            </Box>
            <Box mt={3}>
              {mediaBlobUrl ? (
                <audio src={mediaBlobUrl} controls>
                  <track default kind="captions" srcLang="en" />
                </audio>
              ) : (
                <> </>
              )}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenRecordDialog(false);
            }}
            color="primary"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>close</Icon>
          </Button>
          &nbsp;&nbsp;
          <Button
            onClick={() => {
              clearBlobUrl();
              setRecordedAudio(null);
            }}
            color="error"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>delete</Icon>
          </Button>
          <Button
            color="success"
            variant="outlined"
            iconOnly
            circular
            onClick={() => {
              if (status === "recording") {
                stopRecording();
                setOpenRecordDialog(false);
                return;
              }

              if (recordedAudio === null) {
                setErrorMsg("Audio recording failed");
                showFieldError(true);
                return;
              }
              setOpenRecordDialog(false);
            }}
          >
            <Icon>save</Icon>
          </Button>
        </DialogActions>
      </Dialog>
      <Box>
        <Grid container spacing={3}>
          <Grid item xs={8} md={8} lg={8}>
            <Typography variant="h6" fontWeight="light" fontSize="small" mb={2}>
              {displayName}
            </Typography>
          </Grid>
          <Grid item xs={4} md={4} lg={4}>
            <Box align="right">
              <Button
                iconOnly
                size="small"
                variant="contained"
                color="primary"
                // startIcon={<Icon>location_on</Icon>}
                onClick={() => {
                  setOpenRecordDialog(true);
                }}
              >
                <Icon>settings_voice</Icon>
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box>
        {mediaBlobUrl ? (
          <audio src={mediaBlobUrl} controls>
            <track default kind="captions" srcLang="en" src={mediaBlobUrl} />
          </audio>
        ) : (
          <> </>
        )}
      </Box>
      <input type="hidden" name={`${fieldRef}`} value={recordedAudio} />
    </Box>
  );
}

// Typechecking props of the Transaction
AudioRecorder.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

AudioRecorder.defaultProps = {
  options: null,
};

export default AudioRecorder;
